<template>
    <section class="pt-4">
        <div class="row mx-0 a-center mb-4">
            <p class="col-auto px-0 text-general f-17 f-500">
                Pedidos sin asignar al operador logístico
            </p>
            <div class="col-auto d-middle px-0 ml-auto">
                <i class="icon-history text-general" />
                <span class="text-general2 f-12 f-300 ml-2">Nuevo intento</span>
            </div>
            <div class="col-auto d-middle px-0 ml-2">
                <i class="icon-package-variant f-18 text-general-red" />
                <span class="text-general2 f-12 f-300 ml-2">Productos faltantes</span>
            </div>
            <!-- <div class="col-auto d-middle px-0 ml-2">
                <i class="icon-truck f-18 text-green" />
                <span class="text-general2 f-12 f-300 ml-2">En entrega</span>
            </div> -->
            <el-tooltip placement="bottom" content="Filtro" effect="light">
                <div class="btn-action border ml-2 cr-pointer" @click="abrirFiltro">
                    <i class="icon-filter-outline f-20" />
                </div>
            </el-tooltip>
            <div class="btn-general px-3 f-14 mx-3" @click="asignar()">
                Asignar
            </div>
            <div class="d-flex select-component mr-4">
                <div class="left border-right cr-pointer" :class="componentActive == 'franjasNoAsignados' ? 'active' : ''" @click="componentActive = 'franjasNoAsignados'">
                    <el-tooltip placement="bottom" content="Ver por franjas" effect="light">
                        <i class="icon-column f-14" />
                    </el-tooltip>
                </div>
                <div class="right cr-pointer" :class="componentActive == 'tabla' ? 'active' : ''" @click="componentActive = 'tabla'">
                    <el-tooltip placement="bottom" content="Ver por tabla" effect="light">
                        <i class="icon-menu f-17" />
                    </el-tooltip>
                </div>
            </div>
        </div>
        <component :is="componentActive" :actualizar="actualizar" :filtro="filtro" :bandera="bandera" />
        <!-- Partials -->
        <modal-filtro ref="modalFiltro" @filtrar="filtrar($event)" />
        <modal-asignar-tablero ref="modalAsignarTablero" @actualizar="actualizarData" />
    </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    components:{
        modalFiltro: () => import('../partials/modalFiltro'),
        franjasNoAsignados:  () => import('../components/franjasNoAsignados'),
        tabla:  () => import('../components/tabla'),
        modalAsignarTablero: () => import('../partials/modalAsignarTablero')
    },
    data(){
        return {
            componentActive: 'franjasNoAsignados',
            filtro: {},
            bandera: 'noasignados',
            actualizar: false,
        }
    },
    computed: {
        ...mapGetters({
            id_moneda: 'cedis/id_moneda',
            pedidosFechas: 'routing/tablero/pedidosFechas',
        }),
    },
    methods: {
        abrirFiltro(){
            this.$refs.modalFiltro.toggle(this.bandera);
        },
        filtrar(filtro){
            this.filtro = {...filtro}
        },
        asignar(){
            this.$refs.modalAsignarTablero.toggle(this.pedidosFechas.pedidos, this.id_moneda, this.pedidosFechas.fechas);
        },
        actualizarData(){
            this.actualizar = !this.actualizar;
        },
    }
}
</script>
<style lang="scss" scoped>
.select-component{
    height: 32px;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #CFD7DF;
    .left{
        width: 32px;
        height: 100%;
        border-radius: 8px 0px 0px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000000;
        background-image: linear-gradient(to right, #FFFFFF , #F3F5F7);
        &.active{
            background-color: #000000 !important;
            color: #FFFFFF !important;
            background-image: inherit !important;
        }
    }
    .right{
        width: 32px;
        height: 100%;
        border-radius: 0px 8px 8px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000000;
        background-image: linear-gradient(to right, #FFFFFF , #F3F5F7);
        &.active{
            background-color: #000000 !important;
            color: #FFFFFF !important;
            background-image: inherit !important;
        }
    }
}
.text-green{
    color: #02A251;
}
</style>
